import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgitatorFlateBladePaddle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 140,
	viewBox: "0 0 80.0 140.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 40.0 0.0 L 40.0 60.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 60,
		width: 80,
		height: 80,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgAgitatorFlateBladePaddle;
